export type CostChangeSourceType =
  | "expense"
  | "transformation"
  | "recipe"
  | "conversion"
  | "opening";

export const COST_CHANGE_SOURCE_LABELS: Record<CostChangeSourceType, string> = {
  expense: "Pengeluaran",
  transformation: "Produksi / Repack",
  recipe: "Hitung ulang resep",
  conversion: "Konversi diubah",
  opening: "Stok Awal",
};

export interface ItemCostHistoryEntry {
  id: string;
  itemType: "product" | "raw_material";
  itemId: string;
  costBefore: number;
  costAfter: number;
  sourceType: CostChangeSourceType;
  sourceId: string | null;
  /** e.g. "Repack RPK/202610/0001"; null when the source has no document. */
  sourceLabel: string | null;
  createdByName: string | null;
  createdAt: string;
}

export interface ProductPriceHistoryEntry {
  id: string;
  productId: string;
  /** null for the price a product was created with */
  priceBefore: number | null;
  priceAfter: number;
  createdByName: string | null;
  createdAt: string;
}

export interface ItemHistoryList<T> {
  items: T[];
}
